import { useState } from 'react';
import { FaEnvelope, FaPhone, FaMapMarkerAlt, FaWhatsapp, FaPaperPlane } from 'react-icons/fa';
import SectionTitle from './ui/SectionTitle';
import Button from './ui/Button';
import './Contact.css';

const CONTACT_ITEMS = [
  { icon: <FaMapMarkerAlt />, label: 'Address',        value: 'Sialkot, Punjab, Pakistan' },
  { icon: <FaPhone />,        label: 'Phone / WhatsApp', value: '03160813377' },
  { icon: <FaEnvelope />,     label: 'Email',           value: 'info@ha-surgical.com' },
];

const PRODUCT_OPTIONS = [
  'General Surgical Instruments',
  'Orthopedic Instruments',
  'Dental Instruments',
  'Ophthalmic Instruments',
  'ENT Instruments',
  'Gynecology Instruments',
  'Custom / OEM Order',
];

function ContactInfoItem({ icon, label, value }) {
  return (
    <div className="contact__info-item">
      <div className="contact__info-icon" aria-hidden="true">{icon}</div>
      <div>
        <strong>{label}</strong>
        <p>{value}</p>
      </div>
    </div>
  );
}

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', country: '', product: '', message: '' });
  const [sent, setSent] = useState(false);

  const handleChange = e => setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
  const handleSubmit = e => { e.preventDefault(); setSent(true); };

  return (
    <section className="contact" id="contact">
      <div className="container">
        <SectionTitle
          title="Get in Touch"
          subtitle="Request a quote, ask about custom orders, or simply say hello — we respond within 24 hours"
        />

        <div className="contact__grid">

          <div className="contact__sidebar">
            <h3 className="contact__sidebar-title">Contact Information</h3>
            <p className="contact__sidebar-intro">
              Ready to source premium surgical instruments? Reach out to our export team.
            </p>

            <div className="contact__info-list">
              {CONTACT_ITEMS.map(item => (
                <ContactInfoItem key={item.label} {...item} />
              ))}
            </div>

            <Button
              href="https://wa.me/923160813377"
              variant="whatsapp"
              target="_blank"
              rel="noopener noreferrer"
              className="contact__wa-btn"
            >
              <FaWhatsapp aria-hidden="true" /> Chat on WhatsApp
            </Button>

            <div className="contact__certs">
              <span>ISO 9001</span>
              <span>CE Certified</span>
              <span>FDA Compliant</span>
            </div>
          </div>

          <div className="contact__form-wrap">
            {sent ? (
              <div className="contact__success">
                <FaPaperPlane className="contact__success-icon" aria-hidden="true" />
                <h3>Message Sent!</h3>
                <p>Thank you for reaching out. Our export team will contact you within 24 hours.</p>
                <Button variant="primary" onClick={() => setSent(false)}>
                  Send Another
                </Button>
              </div>
            ) : (
              <form className="contact__form" onSubmit={handleSubmit} noValidate>
                <div className="contact__row">
                  <div className="contact__field">
                    <label htmlFor="cf-name">Your Name *</label>
                    <input id="cf-name" type="text" name="name" placeholder="John Smith"
                      value={form.name} onChange={handleChange} required />
                  </div>
                  <div className="contact__field">
                    <label htmlFor="cf-email">Email Address *</label>
                    <input id="cf-email" type="email" name="email" placeholder="john@example.com"
                      value={form.email} onChange={handleChange} required />
                  </div>
                </div>

                <div className="contact__row">
                  <div className="contact__field">
                    <label htmlFor="cf-phone">Phone / WhatsApp</label>
                    <input id="cf-phone" type="tel" name="phone" placeholder="+1 234 567 8900"
                      value={form.phone} onChange={handleChange} />
                  </div>
                  <div className="contact__field">
                    <label htmlFor="cf-country">Country *</label>
                    <input id="cf-country" type="text" name="country" placeholder="United States"
                      value={form.country} onChange={handleChange} required />
                  </div>
                </div>

                <div className="contact__field">
                  <label htmlFor="cf-product">Product Interest</label>
                  <select id="cf-product" name="product" value={form.product} onChange={handleChange}>
                    <option value="">Select a category...</option>
                    {PRODUCT_OPTIONS.map(opt => (
                      <option key={opt}>{opt}</option>
                    ))}
                  </select>
                </div>

                <div className="contact__field">
                  <label htmlFor="cf-message">Your Message *</label>
                  <textarea id="cf-message" name="message" rows="4"
                    placeholder="Describe the instruments you need, quantities, and any special requirements..."
                    value={form.message} onChange={handleChange} required />
                </div>

                <Button type="submit" variant="primary" fullWidth>
                  <FaPaperPlane aria-hidden="true" /> Send Inquiry
                </Button>
              </form>
            )}
          </div>

        </div>
      </div>
    </section>
  );
}
